import { Popover } from './types';

export const popover_default: Popover = {
  strategy_manage: { is_open: false, is_update: false },
};
